import { blueMui, greenMui, orangeMui, redMui } from "@ryde/theme";

import { IMessagesTypeEnum } from "./messages-display.models";

export interface IMessagesIndicatorControl {
  $bgColor: string;
  $color: string;
  $iconColor: string;
}

export const MessagesIndicatorConst: Record<
  IMessagesTypeEnum,
  IMessagesIndicatorControl
> = {
  [IMessagesTypeEnum.ERROR]: {
    $bgColor: redMui._50,
    $color: redMui.A700,
    $iconColor: redMui.A400,
  },
  [IMessagesTypeEnum.SUCCESS]: {
    $bgColor: greenMui._100,
    $color: greenMui._800,
    $iconColor: greenMui._500,
  },
  [IMessagesTypeEnum.INFO]: {
    $bgColor: blueMui._100,
    $color: blueMui._800,
    $iconColor: blueMui._500,
  },
  [IMessagesTypeEnum.WARNING]: {
    $bgColor: orangeMui._100,
    $color: orangeMui._800,
    $iconColor: orangeMui._500,
  },
};
